import { Typography, Hidden } from '@mui/material';
import Grid from 'components/core/Grid';
import { DividerTemp, StyledBulletList } from '../../components/styles';

const SideBarTrust = () => {
  return (
    <>
      <Hidden mdDown>
        <Grid item xs={12} sm={4} p={2} style={{ borderLeft: '1px solid #ddd' }}>
          <Typography mb={2} fontWeight="500">
            Mountain rentals since 1997
          </Typography>
          <Typography variant="body2" mb={2}>
            List your property on the best Vacation Rental website of Whistler and invite guests from around the world
            to experience.
          </Typography>
          <DividerTemp my={3} />
          <StyledBulletList>
            <li>25+ years in business. alluraDirect has been promoting ski vacation rentals since 1997.</li>
            <li>Experts in ski resort and mountain destination marketing for vacation properties.</li>
            <li>Our guest list is full of repeat, experienced and respectful destination travelers.</li>
            <li>Lower guest service fees than most other global hosting platforms. *</li>
          </StyledBulletList>
          <DividerTemp my={3} />
          <Typography variant="body2">
            1,000,000+ guests have trusted alluraDirect with their vacations, let them find and experience your amazing
            property!
          </Typography>
        </Grid>
      </Hidden>
    </>
  );
};

export default SideBarTrust;
